const state = {
	data: null,
};

const getters = {
	data: state=> state.data,
};

const mutations = {
	data(state, data) {
		state.data = data;
	}
};

const actions = {
	find({commit}, form) {
		const formData = new FormData(form);
		formData.append('class', 'chara-navi');
		formData.append('type', 'find');
		fetch(HOME_URL + '/ajax/member.php', {
			method: 'POST',
			body: formData,
		})
			.then(response => {
				if (response.ok) {
					return response.json();
				}
			})
			.then(result => {
				console.log(result);
				commit('data', result);
			});
	},
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}